import styled, { css } from "styled-components";

export const MainContentsItem = styled.div`
  overflow: auto;
  overflow-x: hidden;
  background: ${(props) => props.theme.colors.white};
  border-radius: 16px;
  box-shadow: ${(props) => props.theme.shadow.box};
  display: grid;
  grid-template-rows: 1fr auto;
  box-sizing: border-box;
  min-width: 0;
`;

export const MainContentsItemLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  box-sizing: border-box;
  min-width: 0;
`;

export const DataHeadBox = styled.div`
  color: ${(props) => props.theme.colors.primary};

  & > div {
    display: flex;
    padding-left: 6px;
    font-size: 1.5rem;
    font-weight: 700;
    align-items: center;
    gap: 8px;
  }
`;

export const MainContentAccordionLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MainContentItemBox = styled.div`
  grid-area: IMC;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DataItemBox = styled.div`
  grid-area: IH;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 10px 0px 10px 0px;
`;

export const DetailDataItemBoxLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 6px;
  min-width: 0;
`;

export const DataListBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 6px;
  min-width: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  padding: 16px;
  margin-top: 20px;
  box-sizing: border-box;
  min-width: 0;

  .small {
    width: 60%;
  }
`;
// import styled, { css } from "styled-components";

// export const MainContentsItem = styled.div`
//   margin-top: 50px;
//   overflow: auto;
//   background: ${(props) => props.theme.colors.white};
//   border-radius: 16px;
//   box-shadow: ${(props) => props.theme.shadow.box};
// `;

// export const MainContentsItemLayout = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 4px;
//   padding: 24px;
// `;

// export const DataHeadBox = styled.div`
//   color: ${(props) => props.theme.colors.primary};

//   & > div {
//     display: flex;
//     padding-left: 6px;
//     font-size: 1.7rem;
//     font-weight: 700;
//     align-items: center;
//     gap: 8px;
//   }
// `;

// export const MainContentAccordionLayout = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 6px;
// `;

// export const MainContentItemBox = styled.div`
//   grid-area: IMC;
//   display: flex;
//   flex-direction: column;
//   gap: 12px;
// `;

// export const DataItemBox = styled.div`
//   grid-area: IH;
//   display: flex;
//   flex-direction: column;
// `;

// export const DataContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 12px;
// `;

// export const DetailDataItemBoxLayout = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   gap: 6px;
// `;

// export const DataListBox = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   gap: 6px;
// `;

// export const ButtonContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: end;
//   padding: 12px;

//   .small {
//     width: 60%;
//   }
// `;
